<div class="quarantine-placement-holder">
  <div class="body-wrapper">
    <div class="form-container">


      <form [formGroup]="form" class="form-container">


        <div class="row">
          <div class="col-12">
            <div class="title-holder">
              <div class="icon">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="9.25" y="1.375" width="3.5" height="19.25" rx="1.75" fill="url(#paint0_linear_29453_866)" stroke="url(#paint1_linear_29453_866)"/>
                  <rect x="20.625" y="9.25" width="3.5" height="19.25" rx="1.75" transform="rotate(90 20.625 9.25)" fill="url(#paint2_linear_29453_866)" stroke="url(#paint3_linear_29453_866)"/>
                  <defs>
                    <linearGradient id="paint0_linear_29453_866" x1="11" y1="0.875002" x2="4.59855" y2="1.42965" gradientUnits="userSpaceOnUse">
                      <stop/>
                      <stop offset="1" stop-color="white"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear_29453_866" x1="12.489" y1="-0.68269" x2="8.35044" y2="0.168649" gradientUnits="userSpaceOnUse">
                      <stop stop-color="white" stop-opacity="0"/>
                      <stop offset="0.428115" stop-color="white" stop-opacity="0.81428"/>
                      <stop offset="1" stop-color="white" stop-opacity="0"/>
                    </linearGradient>
                    <linearGradient id="paint2_linear_29453_866" x1="23.625" y1="20.1815" x2="21.5182" y2="32.1149" gradientUnits="userSpaceOnUse">
                      <stop/>
                      <stop offset="1" stop-color="white"/>
                    </linearGradient>
                    <linearGradient id="paint3_linear_29453_866" x1="24.864" y1="7.19231" x2="20.7254" y2="8.04365" gradientUnits="userSpaceOnUse">
                      <stop stop-color="white" stop-opacity="0"/>
                      <stop offset="0.428115" stop-color="white" stop-opacity="0.81428"/>
                      <stop offset="1" stop-color="white" stop-opacity="0"/>
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <h2 class="form-title">
                Запит на перерозподіл
              </h2>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="organisation">Для закладу</label>
              <app-dropdown
                [multipleSelect]="false"
                [items]="userOrganisationsForList"
                [placeholder]="'Заклад для якого створюється запит'"
                (itemSelected)="onSelectOrganization($event)"
                [isError]="form.controls['organizationId'].invalid && form.controls['organizationId'].touched"
                [fullWidth]="true"
              />
              <p
                  *ngIf="form.controls['organizationId'].invalid && form.controls['organizationId'].touched"
                  class="error-massage">
                Поле обов'язкове до заповнення
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="organisation">Медичний товар</label>
              <app-input
                  placeholder="Введіть Торгову назву чи МНН"
                  [isValid]="form.controls['medicalDevice'].invalid && form.controls['medicalDevice'].touched"
                  (onAction)="onSearch($event)"
              />
              <p
                  *ngIf="form.controls['medicalDevice'].invalid && form.controls['medicalDevice'].touched"
                  class="error-massage">
                Поле обов'язкове до заповнення
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="table-holder">
      <div class="table-wrapper">
        <table>
          <thead>
          <tr>
            <th></th>
            <th>МНН</th>
            <th>Торгова назва</th>
            <th>Дозування</th>
            <th>Напрям</th>
            <th>Кількість</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngIf="medicalDevices.length !== 0 && !isLoading">
            <tr *ngFor="let item of medicalDevices" [class.selected]="item === selectedMedicalDevice" (click)="changeMedicalDevice(item)">
              <td>
                <input type="radio" [value]="item" name="medicalDevice" [class.invalid]="selectedMedicalDeviceError" [checked]="item === selectedMedicalDevice">
              </td>
              <td>{{ item.mnn }}</td>
              <td>{{ item.tradeName }}</td>
              <td>{{ item.dosage === null ? '-' : item.dosage }}</td>
              <td>{{ item.direction }}</td>
              <td>
                <input type="number"
                       [class.error]="maxAmountError || (amount && amount < 1 || isAmountError)"
                       [disabled]="item !== selectedMedicalDevice"
                       (change)="onChangeAmount($event)"
                       min="1"
                       [value]="item === selectedMedicalDevice ? amount : null" />
                <p class="amount-error" *ngIf="maxAmountError">Доступна кількість {{ maxAmount }}. Зменшіть кількість аби продовжити.</p>
                <p class="amount-error" *ngIf="amount && amount < 1 || isAmountError">Кількість повинна бути 1 або більше</p>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="medicalDevices.length === 0 && !isLoading">
            <tr>
              <td [attr.colspan]="6">
                <div class="error-cell-content">
                  <app-error
                      [errorCode]="404"
                  />
                </div>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table>
      </div>
    </div>

  </div>


  <!--  footer-->
  <app-quarantine-placement-footer>
    <div card-left>
      <button (click)="returnToList()" class="button footer-button-back">
      <span>
        <svg fill="none" height="13" viewBox="0 0 14 13" width="14" xmlns="http://www.w3.org/2000/svg">
          <path clip-rule="evenodd"
                d="M5.78033 0.969668C6.07322 1.26256 6.07322 1.73744 5.78033 2.03033L2.81066 5H9.25C11.8733 5 14 7.12663 14 9.75V12.25C14 12.6642 13.6642 13 13.25 13C12.8358 13 12.5 12.6642 12.5 12.25V9.75C12.5 7.95507 11.0449 6.5 9.25 6.5H2.81066L5.78033 9.4697C6.07322 9.7626 6.07322 10.2374 5.78033 10.5303C5.48744 10.8232 5.01256 10.8232 4.71967 10.5303L0.469668 6.28033C0.176777 5.98744 0.176777 5.51256 0.469668 5.21967L4.71967 0.969668C5.01256 0.676777 5.48744 0.676777 5.78033 0.969668Z"
                fill="white"
                fill-rule="evenodd"/>
        </svg>
      </span>
        Відмінити
      </button>
    </div>


    <div card-right>
      <ng-container>
        <button class="button footer-button-yellow" (click)="createRedistributionRequest()">
          Створити запит
          <span>
          <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 2L13 8M13 8L7 14M13 8L2 8" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"/>
          </svg>
        </span>
        </button>
      </ng-container>
    </div>
  </app-quarantine-placement-footer>
</div>


<app-loading-animation *ngIf="isLoading"></app-loading-animation>
